import moment, { Moment } from 'moment';

import { GetEventQuery } from '@graphql';

interface InitialEvent {
  id?: GetEventQuery['event']['id'];
  title: GetEventQuery['event']['title'];
  description?: GetEventQuery['event']['description'] | null;
  from?: GetEventQuery['event']['from'];
  to?: GetEventQuery['event']['to'];
  category?: GetEventQuery['event']['category'];
  isPrivate?: GetEventQuery['event']['isPrivate'];
  participantIds?: string[];
}

export const getMinimalFromDate = (from?: Moment | Date | null) => {
  const nextHour = moment().startOf('hour').add(1, 'hour');

  const minimalFromDate = from
    ? moment(from, 'YYYY-MM-DD').hour(nextHour.hour()).minute(0).second(0).millisecond(0)
    : nextHour;

  if (!moment().isSame(nextHour, 'day')) {
    minimalFromDate.add(1, 'day');
  }

  return minimalFromDate;
};

export default function initValues(event?: InitialEvent | null) {
  const from = getMinimalFromDate(event?.from);
  const to = moment(from).add(1, 'hour');

  return {
    title: event?.title ?? '',
    from: event?.from ? moment(event?.from) : from,
    to: event?.to ? moment(event?.to) : to,
    categoryId: event?.category?.id ?? '',
    isPrivate: event?.isPrivate ?? false,
  };
}
